import { z } from "zod";

export const AddFeaturesSchema = z
  .object({
    advancedStatistics: z.boolean(),
    exportExhibitorsModule: z.boolean(),
    exportProgramModule: z.boolean(),
    isTicketingEnabled: z.boolean(),
    accessControlAccounts: z.number().int().min(0),
    exhibitorProfilesPack1Credits: z.number().int().min(0),
    exhibitorProfilesPack2Credits: z.number().int().min(0),
    exhibitorProfilesPack3Credits: z.number().int().min(0),
    cashRegisterCredits: z.number().int().min(0),
    aiImageCredits: z.number().int().min(0),
    promotion: z.boolean(),
    promotionDates: z.array(z.date()),
    exhibitorPromotion: z.boolean(),
    exhibitorPromotionCredits: z.number().int().min(0),
    eventCustomPdfAppearance: z.boolean(),
    eventCustomAppearance: z.boolean(),
  })
  .strict();

export const defaultAddFeaturesValues: AddFeaturesForm = {
  advancedStatistics: false,
  exportExhibitorsModule: false,
  exportProgramModule: false,
  isTicketingEnabled: false,
  accessControlAccounts: 0,
  exhibitorProfilesPack1Credits: 0,
  exhibitorProfilesPack2Credits: 0,
  exhibitorProfilesPack3Credits: 0,
  cashRegisterCredits: 0,
  aiImageCredits: 0,
  promotion: false,
  promotionDates: [],
  exhibitorPromotion: false,
  exhibitorPromotionCredits: 0,
  eventCustomPdfAppearance: false,
  eventCustomAppearance: false,
};

export type AddFeaturesForm = z.infer<typeof AddFeaturesSchema>;

type NumberKeys<T> = {
  [K in keyof T]: T[K] extends number ? K : never;
}[keyof T];

// Every keys of AddFeaturesForm which are number
export type NumberAddFeaturesForm = Pick<AddFeaturesForm, NumberKeys<AddFeaturesForm>>;
